import APIError from './APIError';

export default class FormError extends APIError {
  static HTTP_CODES = [400, 422];

  static ERROR_CODES = {
    CF_ERROR: 'CF_ERROR',
  };

  static REASONS = {
    CLINICAL_FORM: {
      SPEC_CHANGED: 'spec_changed',
      FORM_EXPIRED: 'formExpired',
      INVALID_SUBMIT: 'invalidSubmit',
    },
  };

  constructor(error) {
    super({ name: 'FormError', message: 'There was an error processing the form' });

    this.response = undefined;
    this.status = undefined;
    this.code = undefined;
    this.reason = undefined;
    this.data = undefined;
    this.parsePayload(error);
  }

  parsePayload(error) {
    const errorResponse = error?.response;
    const errorData = errorResponse?.data;

    this.response = errorResponse;
    this.status = errorResponse?.status;
    this.code = FormError.ERROR_CODES[errorData?.code] || errorData?.code;
    this.reason = errorData?.reason;
    this.data = errorData?.data;
  }

  static matchesFormat(error) {
    const errorStatus = error?.response?.status;
    const errorCode = error?.response?.data?.code;
    if (!errorStatus) return false;

    const hasFormStatus = FormError.HTTP_CODES.includes(errorStatus);
    const hasFormCode = errorCode in FormError.ERROR_CODES;
    return hasFormStatus && hasFormCode;
  }

  static isClinicalForm(error) {
    const reasons = Object.values(FormError.REASONS.CLINICAL_FORM);

    return error instanceof FormError
    && error.code === FormError.ERROR_CODES.CF_ERROR
    && reasons.includes(error.reason);
  }
}
